var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M268,220c0,-0.552 0.448,-1 1,-1c0.552,0 1,0.448 1,1v12c0,0.553 -0.448,1 -1,1c-0.552,0 -1,-0.447 -1,-1v-12v0Zm5,0c0,-0.552 0.448,-1 1,-1c0.552,0 1,0.448 1,1v12c0,0.553 -0.448,1 -1,1c-0.552,0 -1,-0.447 -1,-1v-12v0Zm5,0c0,-0.552 0.448,-1 1,-1c0.552,0 1,0.448 1,1v12c0,0.553 -0.448,1 -1,1c-0.552,0 -1,-0.447 -1,-1v-12v0Zm-15,13c0,2.209 1.791,4 4,4h14c2.209,0 4,-1.791 4,-4v-16h-22v16v0Zm14,-24h-6v-1c0,-0.553 0.448,-1 1,-1h4c0.552,0 1,0.447 1,1v1v0Zm8,0h-6v-2c0,-1.104 -0.896,-2 -2,-2h-6c-1.104,0 -2,0.896 -2,2v2h-6c-1.104,0 -2,0.896 -2,2v2c0,1.104 0.895,1.999 1.999,2h22.003c1.103,-0.001 1.998,-0.896 1.998,-2v-2c0,-1.104 -0.896,-2 -2,-2v0Z",
    transform: "matrix(1,0,0,1,-261,-205)",
    fillRule: "evenodd",
    fill: "#EC7D78",
    stroke: "none"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.251cc8b8c81087c425b0b2a9b1389c0b.svg";
export { ForwardRef as ReactComponent };